import React, { useEffect, useState } from 'react';
import { Search, X } from 'lucide-react';
interface SearchBarProps {
  placeholder?: string;
  className?: string;
  onSearch?: (term: string) => void;
}
export function SearchBar({
  placeholder = 'Buscar...',
  className = '',
  onSearch
}: SearchBarProps) {
  const [term, setTerm] = useState('');
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onSearch) onSearch(term);
    }, 300);
    return () => clearTimeout(timer);
  }, [term, onSearch]);
  return <div className={`relative ${className}`} data-id="element-1008">
      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1009">
        <Search className="h-5 w-5 text-gray-400 dark:text-gray-500" data-id="element-1010" />
      </div>
      <input type="text" value={term} onChange={e => setTerm(e.target.value)} className="block w-full pl-11 pr-10 py-2.5 bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-xl leading-5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent sm:text-sm transition-all duration-200" placeholder={placeholder} data-id="element-1011" />
      {term && <button className="absolute inset-y-0 right-0 pr-4 flex items-center cursor-pointer hover:text-gray-900 dark:hover:text-white text-gray-400 dark:text-gray-500 transition-colors" onClick={() => setTerm('')} data-id="element-1012">
          <X className="h-4 w-4" data-id="element-1013" />
        </button>}
    </div>;
}